import { generalEmptyState } from '@assets/png/imagesPng';
import LocalImage from '@atoms/LocalImage';
import { Text, View } from '@components/primitives';
import colors from '@theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImageStyle, ViewStyle } from 'react-native';
import styles from './styles';

const BPNoDataFound: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <View alignSelf="center" justifyContent="center" flex={1}>
      <View style={styles.containerStyle as ViewStyle}>
        <LocalImage source={generalEmptyState} style={styles.imageStyle as ImageStyle} contentFit="contain" />
      </View>
      <Text variant="md-bold" alignSelf="center" color={colors.neutral.darkMist}>
        {t('bp.unavailableNominalHeader')}
      </Text>
      <Text variant="sm-normal" textAlign="center" marginTop="3px" color={colors.neutral.darkMist}>
        {t('bp.unavailableNominalDescription')}
      </Text>
    </View>
  );
};

export default BPNoDataFound;
